export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-quadtree/index.js
// module id = 79
// module chunks = 0 1 2 3 4